export const isInsideProductColumnPicker = (target: EventTarget | null): boolean =>
  target instanceof Element && Boolean(target.closest(".product-col-picker"));
